import axios from 'axios';
import { supabase } from '../lib/supabase';

export interface CommuneData {
  nom: string;
  code: string;
  codeDepartement: string;
  codeRegion: string;
  codesPostaux: string[];
  population: number;
  logements: number;
}

export async function getCitiesFromPostalCode(postalCode: string): Promise<CommuneData[]> {
  try {
    if (postalCode.length !== 5) return [];

    const { data: communesData, error } = await supabase
      .from('communes')
      .select('code_insee, nom, code_postal, code_departement, code_region, population, logements')
      .eq('code_postal', postalCode);

    if (error) {
      console.error('Erreur lors de la récupération des communes depuis Supabase:', error);
      return fallbackToGeoApi(postalCode);
    }

    if (!communesData || communesData.length === 0) {
      return fallbackToGeoApi(postalCode);
    }

    return communesData.map(commune => ({
      nom: commune.nom,
      code: commune.code_insee,
      codeDepartement: commune.code_departement,
      codeRegion: commune.code_region,
      codesPostaux: [commune.code_postal],
      population: commune.population,
      logements: commune.logements
    }));
  } catch (error) {
    console.error('Erreur lors de la récupération des communes:', error);
    return fallbackToGeoApi(postalCode);
  }
}

async function fallbackToGeoApi(postalCode: string): Promise<CommuneData[]> {
  try {
    const geoResponse = await axios.get(
      `https://geo.api.gouv.fr/communes?codePostal=${postalCode}&fields=nom,code,codeDepartement,codeRegion,codesPostaux,population`,
      {
        timeout: 5000,
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    if (!geoResponse.data || geoResponse.data.length === 0) {
      return [];
    }

    return geoResponse.data.map((commune: any) => {
      const estimatedHouseholdSize = 2.2;
      const population = commune.population || 0;
      const estimatedHousing = Math.round(population / estimatedHouseholdSize);

      return {
        nom: commune.nom,
        code: commune.code,
        codeDepartement: commune.codeDepartement,
        codeRegion: commune.codeRegion,
        codesPostaux: commune.codesPostaux,
        population: population,
        logements: estimatedHousing
      };
    });
  } catch (error) {
    console.error('Erreur lors du fallback vers geo.api.gouv.fr:', error);
    throw new Error('Impossible de récupérer les communes');
  }
}